import { useRef, useCallback, useEffect } from "react";
import { logEvent } from "@firebase/analytics";
import { analytics } from "./firebase";

/**
 * Debounced Firebase Analytics logger
 * @param {string} eventName - The event name (e.g., "button_clicked")
 * @param {number} delay - Debounce delay in ms (default 400)
 */
export const useDebouncedLog = (eventName, delay = 400) => {
  const timeoutRef = useRef(null);

  const debouncedLog = useCallback(
    (params = {}) => {
      // Clear any pending log
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        try {
          logEvent(analytics, eventName, {
            ...params,
            button_name: eventName, // keep your existing pattern if desired
            page: "Login",
            timestamp: Date.now(), // optional: helps debugging
          });
          console.log(`Debounced analytics logged: ${eventName}`, params);
        } catch (er) {
          console.error("Analytics logging error:", er);
        }
      }, delay);
    },
    [eventName, delay]
  );

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debouncedLog;
};